import Image from 'next/image'
import classnames from 'classnames'
import React, {memo} from 'react'
import backSvg from '@/public/img/svg/back.svg'
import {closeWebview} from '@/plugins/bridge'
import {useUaParam} from '@/pages/_app'
import {IS_DEV} from '@/constants/env'

const styles = require('./style.module.less')

interface TitleBarProps {
    type?: 'primary' | 'fixed' | 'sticky';
    children?: React.ReactNode;
    right?: React.ReactNode;
    color?: string;
    backgroundColor?: string;
    opacity?: number;
    hasOccupy?: boolean;
    hasBorder?: boolean;
    back?: () => void;
    content?: string;
    contentStyle?: React.CSSProperties;
    extra?: React.ReactNode;
    background?: string;
}

const TitleBar = (props: TitleBarProps) => {
    const {
        right,
        children,
        color,
        backgroundColor = '#fff',
        opacity,
        back = closeWebview,
        type = 'fixed',
        hasOccupy = false,
        hasBorder = false,
        content,
        contentStyle,
        extra,
        background,
    } = props
    const {
        statusBarHeight,
        titleStatusBarHeight,
        isApp,
    } = useUaParam()
    if (!isApp && !IS_DEV) {
        return null
    }
    return (
        <>
            {
                type === 'sticky' && (
                    <div style={{height: statusBarHeight}}></div>
                )
            }
            <div
                className={classnames({
                    [styles.customNavBar]: true,
                    [styles.border]: hasBorder,
                    [styles.fixed]: type === 'fixed',
                    [styles.sticky]: type === 'sticky',
                })}
                style={{
                    color,
                    marginTop: type === 'sticky' ? 0 : statusBarHeight,
                    opacity,
                    background,
                    backgroundColor,
                }}
            >
                {children || (
                    <div
                        className={styles.content}
                        style={contentStyle}
                    >
                        {content}
                    </div>
                )}
                <div className={styles.back}>
                    <Image
                        src={backSvg}
                        width={32}
                        height={32}
                        priority
                        onClick={back}
                        alt=''
                    />
                </div>
                <div className={styles.right}>
                    {right}
                </div>
                {extra}
            </div>
            {type === 'fixed' && hasOccupy && (
                <>
                    <div
                        className={styles.occupy}
                        style={{
                            height: statusBarHeight,
                            background,
                            backgroundColor,
                        }}
                    >
                    </div>
                    <div style={{minHeight: titleStatusBarHeight, backgroundColor}}></div>
                </>
            )}
        </>
    )
}

export default memo(TitleBar)
